// extracted by mini-css-extract-plugin
module.exports = {"nav":"tabnavigation_nav__TaGn3"};